import {store} from '../redux/store'

// Check if user is authenticated for analytics
export const isAuthenticatedForAnalytics = () => {
  return true
  // const state = store.getState()
  // const user = state.auth.user
  // const token = localStorage.getItem('token')
  // const isLoginPage = window.location.pathname === '/login'
  // const isLoginRedirect = window.location.pathname === '/login-redirect'

  // return !!(user && token && !isLoginPage && !isLoginRedirect)
}

// Get current user data for analytics
export const getAnalyticsUserData = user => {
  try {
    const customerJson = localStorage.getItem('customer')
    const customer = customerJson ? JSON.parse(customerJson) : null

    if (!user || !customer) {
      return null
    }

    return {
      userInfo: {
        Email: user.email,
        FirstName: user.firstName || '',
        LastName: user.lastName || '',
        Role: user.roles.join(', ') || '',
        Id: user.userId,
      },
      schoolName: customer.name,
      schoolId: user.schoolId,
      MatGroupId: user.matGroupId,
    }
  } catch (error) {
    console.error('Error parsing user data for analytics:', error)
    return null
  }
}
